import React from "react";
import { useGoogleLogout } from "@leecheuk/react-google-login";
import { Logout } from "@mui/icons-material";
import { Button, Typography } from "@mui/material";
import Config from "configs/Config";
import UserStore from "stores/UserStore";

import I18n from "../I18n";

export default function GoogleLogoutButton() {
	const userStore = UserStore.getInstance();

	const { signOut } = useGoogleLogout({
		clientId: Config.getInstance().get().googleOauth.web.client_id,
		onLogoutSuccess: async () => {
			await userStore.signOut();
		},
	});

	return <LogoutButton signOut={signOut} />;
}

type IProps = { signOut: () => void };
type IState = Record<string, never>;

class LogoutButton extends React.Component<IProps, IState> {
	public constructor(props: IProps) {
		super(props);
	}

	public override render(): React.ReactNode {
		return (
			<Button variant="outlined" onClick={this.props.signOut} color="info">
				<Logout />
				<Typography variant="body2" ml={2}>
					<I18n map={"components.dashboard_top_bar.logout_button"} />
				</Typography>
			</Button>
		);
	}
}
